import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChevronRight = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.493 2.447a.75.75 0 0 1 1.06.046l7.801 8.509c.128.133.226.289.293.457a1.47 1.47 0 0 1-.293 1.54l-7.801 8.508a.75.75 0 0 1-1.106-1.014L16.234 12 8.447 3.507a.75.75 0 0 1 .046-1.06"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChevronRight;
